module.exports = __webpack_public_path__ + "static/media/moto.31988ad9.svg";